import React from 'react'
import IndexPage from '../index-table/IndexPage'
import MessageAPIService from '@lib/api-services/MessageAPIService';
import  { MessagesAPIService } from '@lib/api-services/MessagesAPIService';
import MessagesTable from '../messages/MessagesTable';
import MessagesIndexTableFiltersPanel from './MessagesIndexTableFiltersPanel';

class MessageIndexPage extends React.Component {
    render() {
        return (
            <IndexPage
                title={__('Messages')}
                options={this.props.options}
                columns={this.props.columns}
                orderOptions={this.props.orderOptions}
                results={this.props.results}
                paging={this.props.paging}
                filter={this.props.filter}
                indexApiService={MessagesAPIService}
                editApiService={MessageAPIService}
                tableComponentClass={MessagesTable}
                filterPanelComponentClass={MessagesIndexTableFiltersPanel}
            />
        );
    }
}

window.components.MessageIndexPage = MessageIndexPage